import React from 'react'

//MUI
import { AppBar, Box, Button, Toolbar } from '@mui/material'

//Router dom
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <AppBar position="sticky" sx={{ backgroundColor: '#fff', zIndex: 2 }} elevation={4}>
            <Toolbar>
                <Box sx={{ gap: '20px', display: 'flex' }} >
                    <Button component={Link} to="/admin/" sx={{ textTransform: 'none', color: '#000' }}>Registro de médicos</Button>
                    <Button component={Link} to="/admin/medicos" sx={{ textTransform: 'none', color: '#000' }}>Médicos</Button>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default Header